// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__gMx9w","actions":"GroupTable_actions___Dc0J","deleteModalFooter":"GroupTable_deleteModalFooter__1-nWe"};